import styled from "styled-components";
import { IKOGImageProps } from "./kogImage";

export const Container = styled.img`
	width: 100%;
	max-width: 200px;
	max-height: 100px;
	object-fit: contain;
`;

export const Image = styled.img<IKOGImageProps>`
	width: 100%;
	max-width: ${({ width }) => (width ? `${width}px` : "200px")};
	max-height: 100px;
	object-fit: contain;
	cursor: default;
`;
